exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-e6f78b2e]{background:#fff;box-shadow:0 0 13px 0 #ddd;border-radius:10px;display:flex;flex-direction:column}.wrapper_fill[data-v-e6f78b2e]{height:100%}.wrapper_loading[data-v-e6f78b2e]{min-height:150px}.wrapper__inner[data-v-e6f78b2e]{height:100%}.wrapper__overlay[data-v-e6f78b2e]{padding:15px;height:100%}", ""]);

// exports
